import {
  CODE_WORLD_CATALOGUE,
  catalogueWorldOfPackage,
  mergeCatalogue,
  packageAliases,
  servedAliasesOf,
  type CatalogueWorld,
  type ServedWorld,
  type WorldCatalogue,
} from '@vrlearning/lesson-schema';

/**
 * The worlds a lesson may be in, as the headset knows them: the code worlds, with the packages the
 * server served (in a code world's place when they share its slug). Later maps win by slug. The
 * headset never refuses a lesson for a world it does not have (`requireKnownWorld` is for the API):
 * a world it cannot build shows the studio. A package whose JSON cannot be read is left out here
 * (prepareWorld refuses it whole when the lesson starts).
 */
export function catalogueOfServed(
  ...served: readonly Readonly<Record<string, ServedWorld>>[]
): WorldCatalogue {
  const bySlug = new Map<string, CatalogueWorld>();
  for (const map of served) {
    for (const world of Object.values(map)) {
      try {
        // A served package's old names travel beside it (spec 2026-10-16).
        const aliases = servedAliasesOf(world.aliases) ?? packageAliases(world.package);
        bySlug.set(world.slug, catalogueWorldOfPackage(world.package, null, undefined, aliases));
      } catch {
        bySlug.delete(world.slug);
      }
    }
  }
  return mergeCatalogue(CODE_WORLD_CATALOGUE, [...bySlug.values()]);
}
